import styled, { css } from 'styled-components'
import InlineSVG from 'react-inlinesvg'
import spacing from 'styles/spacing'
import decorations from 'styles/decorations'
import positioning from 'styles/positioning'
import colors from 'utils/styling/colors'
import type { SVGStyledProps } from 'types/svg'
import { ComponentType } from 'react'

/**
 * react-inlinesvg spreads every prop it receives onto the parsed `<svg>` root,
 * and an `undefined` value in that spread erases the attribute the file
 * declared — erasing a stroke-drawn icon's `fill="none"` root makes every
 * shape fall back to black and paints the icon as a solid silhouette. These
 * props colour the icon through the CSS below instead, so they must never
 * reach the DOM.
 */
const STYLE_ONLY_PROPS = new Set(['fill', 'hoverfill', 'opacity', 'clickable'])

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SVG = styled(InlineSVG as ComponentType<any>).withConfig({
  shouldForwardProp: (prop) => !STYLE_ONLY_PROPS.has(String(prop)),
})(
  ({ fill, hoverfill, opacity, ...props }: SVGStyledProps) => css`
    /* Increase specificity and override any inline styles */
    && {
      path,
      rect,
      circle,
      ellipse,
      polygon,
      polyline,
      line {
        fill: ${colors(fill)};
        opacity: ${opacity};
        transition: fill 0.25s;
      }
    }

    &&:hover {
      path,
      rect,
      circle,
      ellipse,
      polygon,
      polyline,
      line {
        fill: ${colors(hoverfill)};
      }
    }

    ${spacing(props)}
    ${decorations(props)}
    ${positioning(props)}
  `,
)
